import type { NavigationLink } from '@hellodarwin/core/lib/features/entities';
import User from '@hellodarwin/icons/dist/icons/User';

type Translate = (key: string) => string;

export const resolveHeaderUserMenuLinks = (t: Translate): NavigationLink[] => [
  {
    label: t('navigation.settings'),
    pathname: '/profile/contact',
    Icon: User,
  },
];
